import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, ElementRef, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-raw-html',
  template: `<div class="host" #host></div>`,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class RawHtmlComponent implements OnChanges {
  @Input() html = '';

  constructor(private sanitizer: DomSanitizer, private host: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['html']) {
      const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, this.html || '') || '';
      const el = this.host.nativeElement.shadowRoot || this.host.nativeElement;
      el.querySelector('.host')!.innerHTML = sanitized;
    }
  }
}
